import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './mandantenverwaltung-typspezifikation.reducer';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {FunktionsbereichRolle} from '../../../clients/veranstaltungstypen';

export const getModuleState = createFeatureSelector<ModuleState>('MandantenverwaltungTypspezifikationPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);


export const getPandemieTypConfig = createSelector(getPageState, (state: PageState) => state.pandemieTypConfig);
export const getSelectedPandemieTypConfig = createSelector(getPageState, (state: PageState) => state.selectedPandemieTypConfig);

export const getVeranstaltungsTypen = createSelector(getPageState, (state: PageState) => {
    return state.veranstaltungsTypen.map((item) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        item: item,
        itemId: item.veranstaltungstyp_id,
        itemTitle: item.bezeichnung
    });
});
export const getVeranstaltungsTypenLaden = createSelector(getPageState, (state: PageState) => state.veranstaltungsTypenLaden);
export const getVeranstaltungsTypenFehler = createSelector(getPageState, (state: PageState) => state.veranstaltungsTypenFehler);

export const getSelectedTyp = createSelector(getPageState, (state: PageState) => state.selectedTyp);

export const getSelectedTypDetail = createSelector(getPageState, (state: PageState) => state.selectedTypDetail);
export const getSelectedTypDetailLaden = createSelector(getPageState, (state: PageState) => state.selectedTypDetailLaden);
export const getSelectedTypDetailFehler = createSelector(getPageState, (state: PageState) => state.selectedTypDetailFehler);

// ROLLEN/BERECHTIGUNGEN
export const getAdminRollenLoeschenAktiv = createSelector(getPageState, (state: PageState) => state.selectedTypSelectedAdminRollen.length > 0);
export const getAdminRollenSelected = createSelector(getPageState, (state: PageState) => state.selectedTypSelectedAdminRollen);
export const getAdminRollen = createSelector(getPageState, (state: PageState) => {
    if (state.selectedTypAdminRollen === null || state.selectedTypAdminRollen === undefined) {
        return [];
    }
    return state.selectedTypAdminRollen.map((item: FunktionsbereichRolle) => <ListInputItem>{
        groupId: item.funktionsbereich.funktionsbereich_id,
        groupTitle: item.funktionsbereich.titel,
        itemId: item.rolle.rolle_id,
        itemTitle: item.rolle.titel,
        item: item
    });
});
export const getAdminRollenLaden = createSelector(getPageState, (state: PageState) => state.selectedTypAdminRollenLaden);
export const getAdminRollenFehler = createSelector(getPageState, (state: PageState) => state.selectedTypAdminRollenFehler);


export const getSelectedTypFelder = createSelector(getPageState, (state: PageState) => {
    return state.selectedTypFelder.map((item) => <ListInputItem>{
        groupId: '',
        groupTitle: '',
        item: item,
        itemId: item.feld_id,
        itemTitle: item.titel
    });
});
export const getSelectedTypFelderFuerGruppe = createSelector(getPageState, (state: PageState) => {
    return state.selectedTypFelder.filter((item) => item.typ === 'GRUPPE' || item.typ === 'INTSUM');
});
export const getSelectedTypFelderLaden = createSelector(getPageState, (state: PageState) => state.selectedTypFelderLaden);
export const getSelectedTypFelderFehler = createSelector(getPageState, (state: PageState) => state.selectedTypFelderFehler);

export const getSelectedTypFeld = createSelector(getPageState, (state: PageState) => state.selectedTypFeld);

export const getSelectedTypFeldSelectedFeldOption = createSelector(getPageState, (state: PageState) => state.selectedTypFeldSelectedFeldOption);

export const getFelderIds = createSelector(getSelectedTypFelder, (listInputItems: Array<ListInputItem>) => {
    return listInputItems.filter(item => item.itemId).map(item => item.itemId);
});
